import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";

// FNP-328: optional recordId / recordType props let an embedding page (e.g.
// customer-subscriptions Profile Activity tab) render a per-entity activity
// feed. When unset, behaves as the global /activity-logs index page.
export const IndexPage = ({recordId, recordType}: {recordId?: string, recordType?: string} = {}) => {

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper><RecordsTable recordId={recordId} recordType={recordType}/></SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
